export default __webpack_public_path__ + "static/media/googleplay.bd46bc8e.svg";